import script from "./GenerateTrailerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateTrailerPage.vue?vue&type=script&setup=true&lang=js"

import "./GenerateTrailerPage.vue?vue&type=style&index=0&id=7a9db333&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a9db333"]])

export default __exports__